export default __webpack_public_path__ + "static/media/checkbox-active.531f2ec1.svg";